// This is generated.  Alter it in blockGroups/formElements/types/PageAccess.js
/* eslint-disable no-unused-vars */
const { Type } = require('@sinclair/typebox');
const { moduleRegistration } = require('@sstdev/lib_metadata-config');
module.exports = {
  asDataDictionary: function asDataDictionary(hNode, context) {
    const {
      id,
      title,
      propertyName,
      defaultAccessPropertyName = 'defaultAccess',
    } = hNode;
    //This block tells us nothing about namespaces/relations
    const subDataDictionary = {};

    //this block tells us about this current property
    const required = hNode.required ?? hNode.optional === false;
    const {
      isOptional,
      isEditable: editable,
      schemaOptions,
    } = moduleRegistration.resolveFieldFlags(required, context);

    // Helper to create boolean schema
    const createBoolean = (propName, propTitle, isRequired) => {
      const boolSchema = Type.Boolean({
        title: propTitle,
        'x-dataType': 'boolean',
        'x-propertyName': propName,
        'x-optional': !isRequired,
        ...(editable !== undefined && { 'x-editable': editable }),
      });
      return isRequired ? boolSchema : Type.Optional(boolSchema);
    };

    // Create <hNodeId> schema (dynamic boolean property)
    const hNodeIdSchema = Type.Optional(
      Type.Boolean({
        title: 'Allow Access on the given hNode (action or tab)',
        'x-dataType': 'boolean',
        'x-propertyName': '<hNodeId>',
        'x-variableName': true,
        'x-optional': true,
        ...(editable !== undefined && { 'x-editable': editable }),
      }),
    );

    // Create <pageId> schema (dynamic object property)
    const pageIdSchema = Type.Optional(
      Type.Object(
        {
          mobile: createBoolean('mobile', 'Allow Access on Mobile', true),
          desktop: createBoolean('desktop', 'Allow Access on Desktop', true),
          tablet: createBoolean(
            'tablet',
            'Allow Access on Tablet, defaults to the Desktop setting if not set',
            false,
          ),
          '<hNodeId>': hNodeIdSchema,
        },
        {
          title: 'Access to Page',
          'x-dataType': 'object',
          'x-propertyName': '<pageId>',
          'x-variableName': true,
          'x-optional': true,
          ...(editable !== undefined && { 'x-editable': editable }),
          additionalProperties: true,
        },
      ),
    );

    // Create rights object
    const rightsSchema = Type.Optional(
      Type.Object(
        {
          '<pageId>': pageIdSchema,
        },
        {
          title: title,
          'x-dataType': 'object',
          'x-propertyName': 'rights',
          'x-optional': true,
          ...(editable !== undefined && { 'x-editable': editable }),
          additionalProperties: true,
        },
      ),
    );

    // Create defaultAccess boolean
    const defaultAccessSchema = Type.Optional(
      Type.Boolean({
        title: 'Automatically Display New Functionality',
        'x-dataType': 'boolean',
        'x-propertyName': defaultAccessPropertyName,
        'x-optional': true,
        ...(editable !== undefined && { 'x-editable': editable }),
      }),
    );

    // Create the main PageAccess object
    const pageAccessSchema = Type.Object(
      {
        [defaultAccessPropertyName]: defaultAccessSchema,
        rights: rightsSchema,
      },
      {
        'x-id': id,
        title: title,
        'x-dataType': 'object',
        'x-propertyName': propertyName,
        ...schemaOptions,
        additionalProperties: true,
      },
    );

    // a PageAccess component returns the following format:
    const partialTypeDefinition = {
      [propertyName]: isOptional
        ? Type.Optional(pageAccessSchema)
        : pageAccessSchema,
    };

    return [subDataDictionary, partialTypeDefinition];
  },
};
moduleRegistration.registerHNodeType(
  'formElements',
  'PageAccess',
  module.exports,
);
